/* eslint-disable */

import React from "react";
import Image from "../image/Image.tsx";
import FlexRow from "../flex-row/flex-row.tsx";
import AccountAvatar from "../account-avatar/account-avatar.tsx";

const WaterfallIcon = ({
  username,
  urlUser,
  urlOrganisation = null,
  isSmall = false,
  isLarge = false,
  isHuge = false,
}) => {
  var sizeShadow = "w-7 h-7";
  var sizeOrganisation = "w-6 h-6";

  if (isSmall) {
    sizeShadow = "w-5 h-5";
    sizeOrganisation = "w-4 h-auto";
  }

  if (isLarge) {
    sizeShadow = "w-10 h-10";
    sizeOrganisation = "w-8 h-8";
  }

  if (isHuge) {
    sizeShadow = "w-12 h-12";
    sizeOrganisation = "w-10 h-10 md:w-12 md:h-12";
  }

  return (
    <div
      id="waterfall-icon"
      className={`flex flex-col items-end justify-end relative  whitespace-nowrap flex-nowrap  `}
    >
      <AccountAvatar
        presignedUrl={urlUser}
        username={username}
        isSmall={isSmall}
        isLarge={isLarge}
        isHuge={isHuge}
      />

      <div className="flex flex-col absolute items-center justify-center  translate-y-1 ">
        <div
          className={`${sizeShadow} -z-10 bg-transparent dark:bg-color-dark-background-primary absolute rounded-md`}
        />
        {urlOrganisation && (
          <Image
            src={urlOrganisation}
            className={`${sizeOrganisation} rounded`}
          />
        )}
        {urlOrganisation == null && (
          <div className={`${sizeOrganisation} rounded bg-slate-400`} />
        )}
      </div>
    </div>
  );
};

const WaterfallIconV2 = ({
  username,
  urlUser,
  urlOrganisation = null,
  isSmall = false,
  isLarge = false,
  isHuge = false,
}) => {
  var sizeShadow = "w-7 h-7";
  var sizeOrganisation = "w-6 h-6";

  if (isSmall) {
    sizeShadow = "w-5 h-5";
    sizeOrganisation = "w-4 h-auto";
  }

  if (isLarge) {
    sizeShadow = "w-10 h-10";
    sizeOrganisation = "w-8 h-8";
  }

  if (isHuge) {
    sizeShadow = "w-12 h-12";
    sizeOrganisation = "w-9 h-9 md:w-12 md:h-12";
  }

  return (
    <div
      id="waterfall-icon"
      className={`flex flex-col justify-center items-center relative  whitespace-nowrap flex-nowrap  `}
    >
      <div className="flex flex-col items-center justify-center h-20">
        <div className="w-20 h-20 bg-color-raindrop-primary rounded-lg absolute -z-10 "></div>
        <i className="fa fa-droplet text-white text-4xl" />
      </div>
      <FlexRow className="-translate-y-4 " tailwindGap="gap-1">
        <AccountAvatar
          presignedUrl={urlUser}
          username={username}
          isSmall={true}

          // isLarge={isLarge}
          // isHuge={isHuge}
        />

        <div className="flex flex-col  items-center justify-center ">
          <div
            className={`${sizeShadow} -z-10 bg-transparent dark:bg-color-dark-background-primary absolute rounded-md`}
          />
          {urlOrganisation && (
            <Image
              src={urlOrganisation}
              className={`${sizeOrganisation} rounded`}
            />
          )}
          {urlOrganisation == null && (
            <div className={`${sizeOrganisation} rounded bg-slate-400`} />
          )}
        </div>
      </FlexRow>
    </div>
  );
};

const WaterfallIconV3 = ({
  username,
  urlUser,
  urlOrganisation = null,
  isSmall = false,
  isLarge = false,
  isHuge = false,
}) => {
  var sizeShadow = "w-7 h-7";
  var sizeOrganisation = "w-6 h-6";

  if (isSmall) {
    sizeShadow = "w-5 h-5";
    sizeOrganisation = "w-4 h-auto";
  }

  if (isLarge) {
    sizeShadow = "w-10 h-10";
    sizeOrganisation = "w-8 h-8";
  }

  if (isHuge) {
    sizeShadow = "w-12 h-12";
    sizeOrganisation = "w-9 h-9 md:w-12 md:h-12";
  }

  return (
    <div
      id="waterfall-icon"
      className={`flex flex-col justify-center items-center relative  whitespace-nowrap flex-nowrap w-36  `}
    >
      {/* <FlexRow className="translate-y-6">
        <AccountAvatar
          presignedUrl={urlUser}
          username={username}
          isSmall={true}
        />
      </FlexRow> */}
      <div className="flex flex-col items-center justify-center h-20">
        <div className="w-20 h-20 bg-color-raindrop-primary rounded-lg absolute -z-10 "></div>
        <i className="fa fa-droplet text-white text-4xl" />
      </div>
      <FlexRow
        className="-translate-y-6 flex-row-reverse -translate-x-2  "
        tailwindGap="gap-1"
      >
        <div className="flex flex-col  items-center justify-center ">
          <div
            className={`${sizeShadow} -z-10 bg-transparent dark:bg-color-dark-background-primary absolute rounded-md`}
          />
          {urlOrganisation && (
            <Image
              src={urlOrganisation}
              className={`${sizeOrganisation} rounded`}
            />
          )}
          {urlOrganisation == null && (
            <div className={`${sizeOrganisation} rounded bg-slate-400`} />
          )}
        </div>
      </FlexRow>
    </div>
  );
};
export default WaterfallIcon;
